export default __webpack_public_path__ + "eb5faa113168c625f464cc18394fffb8.png";